import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

function loadLocaleMessages () {
	const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
	const messages = {}
	locales.keys().forEach(key => {
		const matched = key.match(/([A-Za-z0-9-_]+)\./i)
		if(matched && matched.length > 1) {
			const locale = matched[1]
			messages[locale] = locales(key)
		}
	})
	return messages
}

const i18n = new VueI18n({
	locale: process.env.VUE_APP_I18N_LOCALE || 'hu',
	// fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
	fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'hu',
	messages: loadLocaleMessages()
});

export default i18n;

/**
 * @param {VueI18n.Path} key
 * @param {VueI18n.Values} [values]
 * @returns {VueI18n.TranslateResult}
 */


export function t(key, values) {
	const lang = window.consentedStorage.getItem('Language') || 'en';
	return i18n.t(key, lang, values);
}
